/*! @wharfkit/sealed-messages v4.0.1 | BSD-3-Clause | Copyright (c) 2025 Greymass Inc. | https://github.com/wharfkit/js */
import { Bytes, Checksum256, Checksum512, Serializer, Struct, UInt64 } from "@wharfkit/antelope";
import { AES_CBC } from "@greymass/miniaes";
//#region \0@oxc-project+runtime@0.147.0/helpers/esm/decorate.js
function __decorate(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
}
//#endregion
//#region src/index.ts
let SealedMessage = class SealedMessage extends Struct {};
__decorate([Struct.field("public_key")], SealedMessage.prototype, "from", void 0);
__decorate([Struct.field("uint64")], SealedMessage.prototype, "nonce", void 0);
__decorate([Struct.field("bytes")], SealedMessage.prototype, "ciphertext", void 0);
__decorate([Struct.field("uint32")], SealedMessage.prototype, "checksum", void 0);
SealedMessage = __decorate([Struct.type("sealed_message")], SealedMessage);
function createSymmetricKey(secret, nonce) {
	return Checksum512.hash(Serializer.encode({ object: nonce }).appending(secret.array)).array.slice(0, 32);
}
function createIV(nonce, secret) {
	return Checksum512.hash(Serializer.encode({ object: nonce }).appending(secret.array));
}
function encryptMessage(iv, symmetricKey, message) {
	const plaintext = Bytes.from(message, "utf8").array;
	const ivBytes = iv.array.slice(32, 48);
	const encrypted = AES_CBC.encrypt(plaintext, symmetricKey, true, ivBytes);
	return Bytes.from(encrypted);
}
function decryptMessage(iv, symmetricKey, message) {
	const ivBytes = iv.array.slice(32, 48);
	return AES_CBC.decrypt(message.array, symmetricKey, true, ivBytes);
}
function sealMessage(message, privateKey, publicKey, nonce) {
	const secret = privateKey.sharedSecret(publicKey, { legacy: true });
	return encryptMessage(createIV(nonce, secret), createSymmetricKey(secret, nonce), message);
}
function sealedMessagePayload(message, privateKey, publicKey, nonce) {
	if (!nonce) nonce = UInt64.random();
	const secret = privateKey.sharedSecret(publicKey, { legacy: true });
	const iv = createIV(nonce, secret);
	const ciphertext = encryptMessage(iv, createSymmetricKey(secret, nonce), message);
	const checksum = new DataView(Checksum256.hash(iv.array).array.buffer).getUint32(0, true);
	return new SealedMessage({
		from: privateKey.toPublic(),
		nonce,
		ciphertext,
		checksum
	});
}
function unsealMessage(message, privateKey, publicKey, nonce) {
	const secret = privateKey.sharedSecret(publicKey, { legacy: true });
	const decryptedMessage = decryptMessage(createIV(nonce, secret), createSymmetricKey(secret, nonce), message);
	return Bytes.from(decryptedMessage).toString("utf8");
}
//#endregion
export { SealedMessage, createIV, createSymmetricKey, decryptMessage, encryptMessage, sealMessage, sealedMessagePayload, unsealMessage };

//# sourceMappingURL=sealed-messages.m.js.map